<template>
  <div id="index">
    <dv-full-screen-container class="bg">
<!--    <div class="bg">-->
<!--      <dv-loading v-if="loading">Loading...</dv-loading>-->
      <div v-if="!loading" class="host-body">
        <router-link to='/'>
        <div class="d-flex jc-center">
         <img src="../assets/top.png" width="100%"/>
        </div>
        </router-link>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2" style="position: relative;
    margin-top: -1rem;z-index: -1">
          <div class="d-flex" style="width: 40%">
          </div>
          <div style="width: 40%" class="d-flex">
            <div class="react-left  mr-3">
              <!--              <span class="text fw-b">vue-big-screen</span>-->
            </div>
            <!--            <div-->
            <!--              class="react-left mr-4"-->
            <!--              style="width: 6.25rem; text-align: right;color:#fff"-->
            <!--            >-->
            <!--              <span class="react-after"></span>-->
            <!--              <span class="text">{{dateYear}} {{dateWeek}} {{dateDay}}</span>-->
            <!--            </div>-->
          </div>
        </div>


        <div class="body-box">
          <!-- 第一列数据 -->
          <div class="content-box">
            <div class="column3">
              <div class="d-flex-center pos">
                <router-link to='/technology'><h2 class="titleMax active">创新主体</h2></router-link>
                <router-link to='/carrierTech'><h2 class="titleMax">科创平台</h2></router-link>
              </div>
              <div class="bg-border" style="height:40vh;">
                <div class="bg-border-inner" >
                  <TotalAmount/>
                </div>
              </div>
<!--              <div class="bg-border" style="height: 30vh">-->
<!--                <div class="bg-border-inner" >-->
<!--                  <TransferNum/>-->
<!--                </div>-->
<!--              </div>-->
              <div class="bg-border" style="height:40vh">
                <div class="bg-border-inner" >
                  <Dynamics/>
                </div>
              </div>
            </div>
            <!-- 第二列数据 -->
            <div class="column4">
              <div style="height:90vh">
                <Map/>
              </div>
<!--              <div class="bg-border" style="height:28vh">-->
<!--                <div class="bg-border-inner" >-->
<!--                  <TotalAmount/>-->
<!--                </div>-->
<!--              </div>-->
            </div>
            <!-- 第三列数据 -->
            <div class="column3">
              <div class="d-flex-center pos">
                <router-link to='/techTalents'><h2 class="titleMax ">科创人才</h2></router-link>
                <router-link to='/achievements'><h2 class="titleMax ">科创成效</h2></router-link>
              </div>
              <div class="bg-border" style="height:40vh">
                              <div class="bg-border-inner" >

                                <MallAmount/>
                              </div>
              </div>
<!--              <div class="bg-border" style="height: 30vh">-->
<!--                <div class="bg-border-inner" >-->
<!--                  <MallNum/>-->
<!--                </div>-->
<!--              </div>-->
              <div class="bg-border" style="height: 40vh">
                <div class="bg-border-inner" >

                  <TransferAmount/>
                </div>
              </div>
            </div>
          </div>
         <Footer></Footer>
        </div>
      </div>
<!--    </div>-->
    </dv-full-screen-container>
  </div>
</template>

<script>
import { formatTime } from '../utils/index.js'
import Map from "@/components/technology/map";
import Dynamics from "@/components/technology/dynamics";
import MallAmount from "@/components/technology/mallAmount";
import TotalAmount from "@/components/technology/totalAmount";
// import MallNum from "@/components/technology/mallNum";
import TransferAmount from "@/components/technology/transferAmount";
// import TransferNum from "@/components/technology/transferNum";
import Footer from "@/components/index/web-footer";
import sciApi from '@/api/index.js'
export default {
  data () {
    return {
      path:'',
      activeName: 'first',
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    };
  },
  components: {
    TotalAmount,//平台交易总金额
    TransferAmount,//成果交易金额
    // TransferNum,//成果交易笔数
    Map,//地图
    Footer,
    Dynamics,//交易动态
    MallAmount,//易智商城交易金额
    // MallNum,//易智商城交易笔数
  },
  watch:{
    typeList1:{
      handler() {
        this.region1=this.typeList1.name
        this.init()
        this.$store.commit('setregion1',this.region1)
      }
    }
  },
  computed:{
    typeList1(){
      return this.$store.state.typeList1
    }

  },
  mounted () {
    this.path=this.$route.name
    this.timeFn();
    this.init();
    this.cancelLoading();
  },
  methods: {
    timeFn () {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000)
    },
    cancelLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
    async init(){
      // const that = this;
      await sciApi.selectSubjects({townStreet:this.region1}).then((data)=>{
        // data 就是接口返回值
        // this.deList = data || {}
        // console.log(data,'this.deList')
        this.$store.commit('setData',data)
      })
    },
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';
.btnList{
  padding: 0.4rem;
  width: 100%;
  margin: 0!important;
}
.btnList .grid-content{
  //float: left;
  //width: 50%;
  height: 1.6rem;
  flex: 1;
  text-align: center;
  font-size: 20px;
  background: #142957;
  margin-bottom: 20px;
  padding-top: 0.3rem;
  border-radius: 0 0.2rem 0 0;
  color:#4c9bfd
}
.btnList .grid-content.active{
  background:#4169E1;
  color: #fff;
}
.btnList .grid-content:hover{
  background:#4169E1;
  color: #fff;
}
.grid-content i{
  width: 100%;
  margin-bottom: 10px;
  font-size: 48px!important;
}
.btnList .grid-content:nth-child(11){
  margin-bottom: 0;
}
.titleMax{
  width: 200px;
  height: 60px;
  font-size: 22px;
  font-weight: normal;
  //border: 1px solid rgb(92, 217, 232);
  background: url(../assets/btn.png)no-repeat center;
  //background-size: cover;
  line-height: 60px;
  padding: 0 0.4rem;
  font-weight: bold;
  //margin-top: 0.2rem;
  margin-bottom: 0.25rem;
  color:#fff;
  text-align: center;
  font-weight: normal;
  cursor: pointer;
}
.titleMax:hover{
  background: url(../assets/hover.png)no-repeat center;
  color: rgb(92, 217, 232);


}
.active{
  background: url(../assets/hover.png)no-repeat center;
  color: rgb(92, 217, 232);
  font-weight: bold;
}
.mt-2{
  margin-top: -15px;
}
.pos{
  position: relative;
  align-items: center;
  //top: -40px;
  width: 100%;
  margin-top: -0.5rem;
  //margin-bottom: 0.2rem;
  //border-bottom: 1px solid #4c9bfd;
}
.pos h2:first-child{
  margin-right: 0.4rem;
}
.d-flex-center{
  display: flex;
  justify-content: center;
}
.titleMax i{
  font-size: 40px;
  line-height: 40px;
  margin-right: 10px;
  vertical-align: middle;
}
</style>